import { render, staticRenderFns } from "./WhopperRegister.vue?vue&type=template&id=01afde86&scoped=true"
import script from "./WhopperRegister.vue?vue&type=script&lang=js"
export * from "./WhopperRegister.vue?vue&type=script&lang=js"
import style0 from "./WhopperRegister.vue?vue&type=style&index=0&id=01afde86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afde86",
  null
  
)

export default component.exports